module.exports = __webpack_public_path__ + "img/光谷华为.06d5a330.png";